export default (ACCESS_TOKEN_CONFIG) => {
    const service = {}
    const { localStorage } = window

    service.updateAccessTokenConfig = (expiresAt, refreshToken, username, clientId, clientSecret, isStayConnected) => {
        const accessTokenConfig = service.getAccessTokenConfig()
        const newValuesObject = removeNullValues({
            expiresAt,
            refreshToken,
            username,
            clientId,
            clientSecret,
            isStayConnected,
        })
        const updatedObject = accessTokenConfig ? { ...accessTokenConfig, ...newValuesObject } : newValuesObject
        localStorage.setItem(ACCESS_TOKEN_CONFIG, JSON.stringify(updatedObject))
    }

    service.deleteAccessTokenConfig = () => {
        localStorage.removeItem(ACCESS_TOKEN_CONFIG)
    }

    service.getAccessTokenConfig = () => {
        return JSON.parse(localStorage.getItem(ACCESS_TOKEN_CONFIG))
    }

    return service
}

const removeNullValues = (object) => {
    const objectWithoutNullValues = {}
    Object.keys(object).map((key) => {
        if (object[key]) objectWithoutNullValues[key] = object[key]
    })
    return objectWithoutNullValues
}
